var render = function render(){var _vm=this,_c=_vm._self._c;return _c('box',{class:_vm.getClass,attrs:{"id":_vm.dom_id}})
}
var staticRenderFns = []

export { render, staticRenderFns }